import { FC, ReactNode } from 'react';

import styles from './NavigationBody.module.scss';

export type NavigationBodyProps = {
  children?: ReactNode;
};

export const NavigationBody: FC<NavigationBodyProps> = ({ children }) => {
  return <div className={styles.navigationBody}>{children}</div>;
};
